import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { guaranteeItems } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Guarantee() {
  return <section className="bg-cream-100 px-5 py-16 md:py-24" data-id="element-153" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-3xl text-center" data-id="element-154" data-mp="24l3v7faegfni">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full bg-navy-900 text-gold-400 ring-4 ring-gold-400 ring-offset-4 ring-offset-cream-100" data-id="element-155" data-mp="29eyjkw0y9isx">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-156" data-mp="2jbl1pd1w5vr9" />
          <span className="mt-1 font-serif text-lg font-extrabold leading-none" data-id="element-157" data-mp="2jdxl7unase6f">7 days</span>
        </div>
        <h2 className="mt-8 font-serif text-3xl font-bold leading-tight text-navy-950 md:text-5xl" data-id="element-158" data-mp="2scsooyyyja61">
          7-day guarantee. <em className="text-gold-700" data-id="element-159" data-mp="txocpzcqv58f">No risk.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-160" data-mp="tz95bjfi0e3n">
          I want you to explore Rhinoplasty MasterMap™ without unnecessary risk. For the next 7 days, you can:
        </p>

        <ul className="mx-auto mt-8 grid max-w-2xl gap-2 text-left sm:grid-cols-2" data-id="element-161" data-mp="3sn9fou183t5v">
          {guaranteeItems.map(g => <li key={g} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 text-[15px] font-medium text-ink ring-1 ring-cream-200" data-id="element-162" data-mp="3iv3sryptw1xj">
              <CheckIcon className="h-4 w-4 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-163" data-mp="3dydbj82af0aj" />
              {g}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-[15px] leading-relaxed text-muted" data-id="element-164" data-mp="agv59525y1c8">
          If you review the system and decide it doesn't provide value for your educational workflow, you can request a refund within the 7-day guarantee period, subject to the purchase terms.
        </p>

        <CtaButton className="mt-10" label="Try it risk-free" note="7 days to try it · Full refund if it's not for you" data-id="element-165" data-mp="2q77wgv468c1a" />
      </div>
    </section>;
}